/* eslint-disable max-len */
import React from 'react';
function NoBreak() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.41421 2L1 3.41421L5 7.41421V13.4142C5 15.6242 6.79 17.4142 9 17.4142H15L17 19.4142H3V21.4142H19L20.5204 22.9346L21.9346 21.5204L2.41421 2ZM13 15.4142L7 9.41421V13.4142C7 14.5142 7.9 15.4142 9 15.4142H13ZM17 13.4142C17 13.5308 16.9899 13.645 16.9705 13.7563L18.5237 15.3095C18.8276 14.7455 19 14.1001 19 13.4142V10.4142H21C22.11 10.4142 23 9.52421 23 8.41421V5.41421C23 4.30421 22.11 3.41421 21 3.41421H6.62848L8.62848 5.41421H17V13.4142ZM19 8.41421V5.41421H21V8.41421H19Z" })));
}
export default NoBreak;
